import { createFileRoute, Link } from '@tanstack/react-router'
import { ArchiveIcon } from 'lucide-react'

import { BreadcrumbTrail, Button, PageHeader } from '@/components/ui'
import {
  ArchivedProjectsList,
  ProjectsList,
} from '@/modules/projects/components'

export const Route = createFileRoute('/_authenticated/projects/')({
  staticData: { title: 'Projects' },
  component: ProjectsListView,
  shouldReload: false,
  validateSearch: (search: Record<string, unknown>) => ({
    view: search.view === 'archived' ? ('archived' as const) : undefined,
  }),
})

function ProjectsListView() {
  const { view } = Route.useSearch()

  if (view === 'archived') {
    return (
      <div className="space-y-6">
        <BreadcrumbTrail
          crumbs={[{ label: 'Projects', to: '/projects' }]}
          page="Archived"
        />

        <PageHeader title="Archived projects" />

        <ArchivedProjectsList />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <BreadcrumbTrail page="Projects" />

      <PageHeader title="Projects" subtitle="Projects overview.">
        <Button asChild theme="outline">
          <Link to="/projects" search={{ view: 'archived' }}>
            <ArchiveIcon className="size-4" />
            Archived projects
          </Link>
        </Button>
      </PageHeader>

      <ProjectsList />
    </div>
  )
}
